<div class="search-bar" tabindex="0">
  @if (iconUrl) {
    <img [src]="iconUrl" alt="" class="search-bar__bar-icon" />
  } @else {
    <span class="material-symbols-outlined search-bar__bar-icon">search</span>
  }
  <input
    type="text"
    class="search-bar__bar"
    (focus)="showCloseIcon()"
    (click)="showCloseIcon()"
    (input)="setSearchValue($event)"
    [(ngModel)]="searchBar"
    [placeholder]="placeholder"
  />
  <span
    class="material-symbols-outlined search-bar__close-icon"
    [class.search-bar__close-icon--active]="isBtnClose"
    (click)="cleanSearchBar()"
    (mousedown)="preventBlur($event)"
  >close</span>
</div>
